import * as React from 'react';
import {connect} from 'react-redux';
import Scrollbar from 'react-smooth-scrollbar';
import {RouteComponentProps, withRouter} from 'react-router';
import classNames from 'classnames';
import SidebarContent from './sidebar-content';
import {changeMobileSidebarVisibility} from '../../../../theme/redux/actions/sidebarActions';

interface SidebarProps {
    sidebar: any;
    dispatch: (action: any) => (any);
}

const mapStateToProps = (state) => {
    const stateProps = {
        sidebar: state.sidebar
    };
    return stateProps;
};

class Sidebar extends React.PureComponent<SidebarProps & RouteComponentProps<any>, {}> {

    private changeMobileSidebarVisibility = () => {
        this.props.dispatch(changeMobileSidebarVisibility());
    };

    public render() {
        const sidebarClass = classNames({
            'sidebar': true,
            'sidebar--collapse': this.props.sidebar.collapse,
            'sidebar--show': this.props.sidebar.show
        });

        return (
            <div className={sidebarClass}>
                <div className='sidebar__back' onClick={this.changeMobileSidebarVisibility}/>
                <Scrollbar className='sidebar__scroll scroll'>
                    <div className='sidebar__wrapper sidebar__wrapper--desktop'>
                        <SidebarContent onClick={() => {return}}/>
                    </div>
                    <div className='sidebar__wrapper sidebar__wrapper--mobile'>
                        <SidebarContent onClick={this.changeMobileSidebarVisibility}/>
                    </div>
                </Scrollbar>
            </div>
        )
    }
}

export default withRouter(connect(mapStateToProps)(Sidebar));


// WEBPACK FOOTER //
// ./src/components/common/layout/sidebar/sidebar.tsx